import { create } from "zustand";
import { TestAddress, TestPaymentData, TestPaymentState } from "../types";

export const useTestPaymentStore = create<TestPaymentState>((set, get) => ({
  paymentData: null,
  error: null,
  testAddress: null,

  setPaymentData: (updater: (currentData: TestPaymentData | null) => TestPaymentData | null) => {
    const { paymentData } = get();
    const updatedData = updater(paymentData);
    set({
      paymentData: updatedData,
      error: null
    });
  },

  setError: (errorMessage: string | null) => {
    set({ error: errorMessage });
  },

  removeItem: (itemId: string) => {
    const { paymentData } = get();
    if (!paymentData) return;

    const updatedTests = paymentData.tests.filter(test => test._id !== itemId);

    set({
      paymentData: {
        ...paymentData,
        tests: updatedTests
      }
    });
  },

  setTestAddress: (address: TestAddress) => {
    set({ testAddress: address });
  }
}));


